import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import Loader from 'components/Loader';
import { FC } from 'react';

interface Props {
  children?: React.ReactNode;
  footerVisible?: boolean;
  headerVisible: boolean;
  isLoading: boolean;
  hasIssues?: boolean;
}

const HeaderAndFooterLayout: FC<Props> = ({
  children,
  footerVisible = true,
  headerVisible,
  isLoading,
  hasIssues,
}) => (
  <>
    {headerVisible && <Header hasIssues={hasIssues} />}
    {isLoading ? (
      <div className="loader-center">
        <Loader width={60} height={60} />
      </div>
    ) : (
      children
    )}
    {footerVisible && <Footer />}
  </>
);

export default HeaderAndFooterLayout;
